import { StatisticsForGoogleAnalytics } from "api/http-client/types";

export const pushServerDataToGTM = (data: StatisticsForGoogleAnalytics) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "data_update",
    total_number_of_quilts: `${data.totalNumberOfQuilts}`, 
    total_number_of_quilts_public: `${data.totalNumberOfQuiltsPublic}`,        
    total_number_of_quilts_private: `${data.totalNumberOfQuiltsPrivate}`, 
    total_number_of_quilts_solo: `${data.totalNumberOfQuiltsSolo}`, 
    total_creator_accounts: `${data.totalCreatorAccounts}`, 
    total_creator_accounts_published: `${data.totalCreatorAccountsPublished}`, 
    total_creator_accounts_unpublished: `${data.totalCreatorAccountsUnpublished}`, 
    total_creator_accounts_collaboration: `${data.totalCreatorAccountsCollaboration}`,
  });
  sessionStorage.setItem("serverDataPushed", "true");
};
